
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Tooltip } from 'element-ui';
import api from '@/api/course';
import tModal from '@/components/Modal/index.vue';
import { IORGSTATE } from '@/store/state.d';

@Component({
  components: {
    Tooltip,
    tModal,
  },
})
export default class InfoCard extends Vue {
  private showInfo: {
    type?: string,
    icon?: string,
    cover?: string,
    title?: string,
    version?: string,
    abstract?: string,
  } = {};

  private show: boolean = false;

  private loading: Boolean = false;

  mounted() {
    this.getData();
  }

  getData() {
    this.loading = true;
    api.getCourseDetail(Base64.decode(this.$route.params.pid) || '').then((res: any) => {
      this.showInfo = {
        icon: res.courseIco,
        cover: res.courseImage,
        title: res.courseTitle,
        version: res.courseVersion,
        abstract: res.courseDesc,
        type: res.typePath,
      };
      this.loading = false;
    });
  }
}
